/**
 * refresh list when pull down
 */
(function (angular) {
    var PullToRefreshController = function () {
        // Constructor for the PullToRefreshController
        function PullToRefreshController() {
            this.init.apply(this, arguments); // Initialize the controller
        }

        // Dependency injection for AngularJS
        PullToRefreshController.$inject = ['$scope', '$element'];

        // Define the prototype methods for the controller
        PullToRefreshController.prototype = {
            /**
             * Initialization function
             * @param $scope{angular.IScope}
             * @param $element{jQuery}
             */
            init: function ($scope, $element) {
                this.$scope = $scope;
                this.$element = $element;

                // Init
                this.requiredPercentage= 60;
                this.percentage = 0;
                this.scrollerContainer = null;


                // Bind touch events to the element
                $element.bind("touchend", this.onTouchEnd.bind(this));
                $element.bind("touchmove", this.onTouchMove.bind(this));
                $element.bind("touchstart", this.onTouchStart.bind(this));
            },


            /**
             * Set scrollTop
             * @param top {number}
             */
            setScrollerTop :function(top){
                let scroller = this.scrollerContainer ? this.scrollerContainer: this.$element.find(this.scroller).get(0);
                if(scroller) {
                    scroller.scrollTop = top;
                }
            },
            /**
             * Get scrollTop of scroller
             * @returns {number}
             */
            getScrollerTop: function(){
                let scroller = this.scrollerContainer ? this.scrollerContainer: this.$element.find(this.scroller).get(0);
                if(scroller){
                    return scroller.scrollTop;
                } else{
                    return 0;
                }
            },

            // Handle touch start event
            onTouchStart: function (event) {
                this.slideBeginY = event.changedTouches[0].pageY; // Store initial touch position
                this.scrollerContainer = this.$element.find(this.scroller).get(0);
            },

            // Handle touch move event
            onTouchMove: function (event) {
                this.currentMousePosition = event.changedTouches[0].clientY; // Update current mouse position

                // Check if user has reached the top of the scrollable area
                if (!this.reachedTheTop) {
                    var allowUp = this.getScrollerTop() > 1; // Allow upward movement
                    var up = event.changedTouches[0].pageY > this.slideBeginY; // Determine if moving up
                    var down = event.changedTouches[0].pageY < this.slideBeginY; // Determine if moving down
                    this.slideBeginY = event.changedTouches[0].pageY; // Update the starting position

                    // If the user is pulling down and not allowed to scroll up
                    if (up && !allowUp && !down) {
                        this.reachedTheTop = true; // Mark that the top is reached
                        this.refreshStartPosition = this.currentMousePosition; // Store the start position for refresh
                    }
                } else {
                    // Update the progress bar if top is reached
                    this.progressBarUpdate(this.refreshStartPosition, this.currentMousePosition);
                }
            },
            // Handle touch end event
            onTouchEnd: function () {
                var _this = this;
                if (this.reachedTheTop) {
                    this.reachedTheTop = false; // Reset the top reached flag

                    // Check if a refresh is needed based on the current position
                    if (this.isRefreshNeeded(this.currentMousePosition, this.refreshStartPosition)) {
                        this.progressBarToRefreshPosition(); // Indicate refresh is in progress
                        if (this.refresh) {
                            this.refresh().finally(function () {
                                _this.progressBarRestore(); // Restore progress bar after refresh
                            });
                        } else {
                            this.progressBarRestore(); // Restore progress bar if no refresh is needed
                        }

                    } else {
                        this.setScrollerTop(0)// Reset scroll position
                        this.progressBarRestore(); // Restore progress bar if no refresh is needed
                    }
                }
            },

            // Determine if a refresh is needed based on the mouse positions
            isRefreshNeeded: function (currentMousePosition, refreshStartPosition) {
                return currentMousePosition - refreshStartPosition > this.requiredPercentage; // Check if pulled down enough
            },

            // Calculate the percentage of pull based on positions
            getPercentage: function (refreshStartPosition, currentMousePosition) {
                return Math.max(Math.min((currentMousePosition - refreshStartPosition) / this.requiredPercentage * 100, 100), 0);
            },
            // Restore the progress bar to its initial state
            progressBarRestore: function () {
                this.$element.addClass('notransition'); // have to stop transition 
                this.refreshingInProgress = false; // Indicate no refresh in progress
                this.percentage = 0;
                this.updateIcon();
                this.setProgressBarPosition(0); // Reset position
                this.$element.removeClass('notransition');
            },
            // Set the progress bar to indicate refresh is in progress
            progressBarToRefreshPosition: function () {
                this.refreshingInProgress = true; // Indicate refresh is in progress

                this.updateIcon();
                this.setProgressBarPosition(60);
            },
            // Set the position of the progress bar based on how far it has been pulled down
            setProgressBarPosition: function (pulledDown) {
                // Calculate the translation based on pulled down distance
                var translation = Math.min(pulledDown, $(window).innerHeight() * this.requiredPercentage) + Math.max(pulledDown - $(window).innerHeight() * this.requiredPercentage, 0) * 0.1;
                if (translation < 0) {
                    translation = 0;
                }
                var transform = 'translate(0px,' + translation + 'px)';
                this.$element.css({
                    transform: transform,
                    webkitTransform: transform,
                    MozTransform: transform,
                    msTransform: transform,
                    OTransform: transform
                });
            },
            // Update the progress bar based on the current and start positions
            progressBarUpdate: function (refreshStartPosition, currentMousePosition) {
                var pulledDown = currentMousePosition - refreshStartPosition; // Calculate pulled down distance
                this.percentage = this.getPercentage(refreshStartPosition, currentMousePosition); // Get the percentage

                this.updateIcon();

                // Update the progress bar's position, color, and angle
                this.setProgressBarPosition(pulledDown);
            },
            // Update the loading icon based on the state
            updateIcon: function () {
                this.resetClass(); // Reset classes
                if (this.percentage >= 100) {
                    this.$element.addClass("is-refresh"); // Add refresh class
                }

                if (this.refreshingInProgress) {
                    this.$element.addClass('is-playing-animation'); // Add animation class
                }
            },

            // Reset the classes on the loading container
            resetClass: function () {
                this.$element.removeClass("is-refresh is-playing-animation");
            }
        };
        return PullToRefreshController; // Return the controller
    }();

    // Define the AngularJS module and component
    angular.module('pullToRefresh', []).component('pullToRefresh', {
        templateUrl: 'js/shared/directives/pull-to-refresh/pull-to-refresh.html',
        // Template URL
        bindings: {
            refresh: '&',
            // Binding for the refresh function
            scroller: '@' // Binding for enabling/disabling the component
        },

        transclude: true,
        // Allow content to be transclude
        controller: PullToRefreshController // Set the controller
    });
})(angular);